(function () {
  'use strict';

  var VIEW_KEY = 'devora_collection_view';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initSort(select) {
    if (!select || select.dataset.devoraSortReady === 'true') return;
    select.dataset.devoraSortReady = 'true';
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  }

  function setViewMode(mode, productList, buttons) {
    if (!productList) return;

    productList.classList.toggle('devora-product-list--list', mode === 'list');
    productList.classList.toggle('devora-product-list--grid', mode !== 'list');
    localStorage.setItem(VIEW_KEY, mode);

    buttons.forEach(function (btn) {
      var active = btn.dataset.devoraViewMode === mode;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function openDrawer(drawer, trigger) {
    drawer.hidden = false;
    document.body.classList.add('devora-facet-drawer-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer(drawer, trigger) {
    drawer.hidden = true;
    document.body.classList.remove('devora-facet-drawer-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  ready(function () {
    var root = document.querySelector('.devora-collection--fandi');
    if (!root) return;

    var productList = root.querySelector('.product-list');
    var viewButtons = root.querySelectorAll('[data-devora-view-mode]');
    var filterOpen = root.querySelector('[data-devora-filter-open]');
    var drawer = root.querySelector('[data-devora-facet-drawer]');
    var sortSelect = root.querySelector('.sort-by-box-okay');

    initSort(sortSelect);

    var savedView = localStorage.getItem(VIEW_KEY) || 'grid';
    setViewMode(savedView, productList, viewButtons);

    viewButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setViewMode(btn.dataset.devoraViewMode, productList, viewButtons);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer && !drawer.hidden) {
        closeDrawer(drawer, filterOpen);
      }
    });

    if (filterOpen && drawer) {
      filterOpen.addEventListener('click', function () {
        openDrawer(drawer, filterOpen);
      });

      drawer.querySelectorAll('[data-devora-filter-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          closeDrawer(drawer, filterOpen);
        });
      });
    }
  });
})();
